module.exports = __webpack_public_path__ + "static/media/PC_Carrosel_API_GATEWAY.651aeddb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/APIGATEWAY/PC_Carrosel_API_GATEWAY.png
// module id = 197
// module chunks = 0